import { Component } from '@angular/core';
import { BasicInformationService } from '../../../shared/services/basic-information.service';
import { NewsModel } from '../../../shared/models/news.model';

@Component({
  selector: 'app-afra-magazine',
  templateUrl: './afra-magazine.component.html',
  styleUrls: ['./afra-magazine.component.css'],
  standalone: false,
})
export class AfraMagazineComponent {
  newsItems: NewsModel[] = [];

  constructor(private basicInformationService: BasicInformationService) {}
  ngOnInit() {
    this.basicInformationService.getAfraNews().subscribe((response) => {
      this.newsItems = response;
    });
  }
}
